import React from "react";
import styled from "styled-components";

const Agenda = () => {
  return (
    <Wrapper>
      <Container>
        <Title>
          <h2>Agenda</h2>
        </Title>
        <Grid>
          <Timeslot>
            <p />
          </Timeslot>
          <Details>
            <p>
              <strong>Meeting Chair,</strong> Annmarie O'Connor
            </p>
          </Details>
        </Grid>
        <Grid>
          <Timeslot>
            <p>11.00h - 11:10h</p>
          </Timeslot>
          <Details>
            <h3>Chair: Introduction</h3>
            <p>Annmarie O'Connor</p>
          </Details>
        </Grid>
        <Grid>
          <Timeslot>
            <p>11.10h - 11:15h</p>
          </Timeslot>
          <Details>
            <h3>Welcome & Opening Address</h3>
            <p>Shane O'Brien</p>
          </Details>
        </Grid>
        <Grid>
          <Timeslot>
            <p>11:15h - 11:45h</p>
          </Timeslot>
          <Details>
            <h3>
              Supporting Life with Parkinson's: The Role of Community
              Physiotherapy
            </h3>
            <p>Cathy O'Shea</p>
          </Details>
        </Grid>
        <Grid>
          <Timeslot>
            <p>11:45h - 12:10h</p>
          </Timeslot>
          <Details>
            <h3>
              Minimizing Risks, Maximizing Benefits: Safe Medication use in
              Parkinson's 
            </h3>
            <p>Niamh O'Hanlon</p>
          </Details>
        </Grid>
        <Grid>
          <Timeslot>
            <p>12:10h - 12:25h</p>
          </Timeslot>
          <Details>
            <h3>
              The Relationship Between You and Your Neurologist: Communication,
              Partnership, and Getting the Most Out of Clinical Appointments
            </h3>
            <p>Dr. Deborah McIntyre</p>
          </Details>
        </Grid>
        <Grid>
          <Timeslot>
            <p>12:25h - 12:50h</p>
          </Timeslot>
          <Details>
            <h3>
              Navigating Employment After an Early Parkinson's Disease Diagnosis
            </h3>
            <p>Catriona Kinnevey</p>
          </Details>
        </Grid>
        <Grid>
          <Timeslot>
            <p>12:50h - 13:15h</p>
          </Timeslot>
          <Details>
            <h3>
              What Is Happening with Stem Cell
              <br />
              Therapies for Parkinson's?
            </h3>
            <p>Professor Eilis Dowd</p>
          </Details>
        </Grid>
        <Grid>
          <Timeslot>
            <p>13:15h - 13:35h</p>
          </Timeslot>
          <Details>
            <h3>
              Discovering Molecular Signatures
              <br />
              in Parkinson's
            </h3>
            <p>Dr. Niamh Connolly</p>
          </Details>
        </Grid>
        <Grid>
          <Timeslot>
            <p>13:35h - 13:55h</p>
          </Timeslot>
          <Details>
            <h3>Close</h3>
            <p>Annmarie O'Connor</p>
          </Details>
        </Grid>
        {/*         <Grid>
          <Timeslot>
            <p>13:55h - 14:00h</p>
          </Timeslot>
          <Details>
            <h3>TBC</h3>
          </Details>
        </Grid> */}
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: #ffffff;
`;

const Title = styled.div`
  position: absolute;
  top: 2rem;
  left: -1rem;
  transform: translateY(-50%);
  background-color: var(--abbvie-blue);
  padding: 1rem 2rem;
  h2 {
    color: #ffffff;
    font-family: "League Spartan", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 1.25rem;
    line-height: 1.5rem;
    text-transform: uppercase;
  }
  @media (min-width: 768px) {
    padding: 1.5rem 3rem 1.5rem 8rem;
    left: -4.5rem;
    h2 {
      font-size: 32px;
      line-height: 38px;
    }
  }
`;

const Details = styled.div`
  grid-column: 1/7;
  color: var(--abbvie-green);
  display: flex;
  flex-direction: column;
  color: var(--abbvie-dark-green);
  h3 {
    margin-bottom: 0.15em;
    font-size: 1.25rem;
    font-family: "League Spartan", sans-serif;
    font-style: normal;
    max-width: 600px;
    font-weight: 700;
  }
  p {
    font-size: 1.25rem;
    font-family: "League Spartan", sans-serif;
    font-style: normal;
    font-weight: 400;
    max-width: 600px;
    strong {
      font-weight: 700;
    }
  }
  a {
    color: var(--abbvie-green) !important;
    p {
      text-decoration: underline;
    }
  }
  @media (min-width: 768px) {
    h3 {
      font-size: 1.25rem;
    }
    p {
      font-size: 1.25rem;
    }
  }
  @media (min-width: 1150px) {
    grid-column: 3/13;
  }
`;

const Timeslot = styled.div`
  grid-column: 1/7;
  p {
    font-family: "League Spartan", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    color: var(--abbvie-bright-green);
  }
  @media (min-width: 1150px) {
    grid-column: 1/3;
    p {
      font-size: 1.25rem;
    }
  }
`;

const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 0.875rem;
  align-items: start;
  margin: 1rem 0;
  @media (min-width: 1150px) {
    grid-gap: 2rem;
    grid-template-columns: repeat(12, 1fr);
  }
`;

const Container = styled.div`
  width: 100%;
  padding: 3rem 1rem 1rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  width: 98%;
  max-width: 1300px;
  margin: 3rem auto;
  background: rgba(3, 147, 44, 0.1);
  z-index: 2;
  @media (min-width: 768px) {
    padding: 5rem;
  }
  @media (min-width: 1150px) {
    margin: 5rem auto 8rem auto;
    padding-top: 2rem;
  }
`;

export default Agenda;
